import GenericUpload from './FileType/GenericUpload'
import JsonUpload from './FileType/JsonUpload'
import { UploadProps, UploadTypes } from './types'

export default function Upload(props: UploadProps) {
  switch (props.type) {
    case UploadTypes.json:
      return <JsonUpload {...props}></JsonUpload>
    default:
      return <GenericUpload {...props}></GenericUpload>
  }
}
